import axios from "axios";
import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectVipcardRecoder(data) {
  return request({
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded",
    // },
    url: `/admin/mall/vipcardRecode/select`,
    method: "POST",
    data,
  });
}

/**
 * 新增
 * @param {*} data
 * @returns
 */
export function addVipcardRecoder(data) {
  return request({
    url: `/admin/mall/vipcardRecode/add`,
    method: "POST",
    data,
  });
}
